module.exports = __webpack_public_path__ + "media/images/career_camp/2023/left-paddle-9d1204d3275d547625024a099c48b866.svg";